import { isFeatureFlagEnabledHTML } from 'www/utils'
import sendYaGoal from 'www/vue_components/common/AppointmentPage/functions/sendYaGoal'
import { TOWN_ONLINE_GOALS } from 'www/yandexGoals'

const dataTownOnlineAttrName = 'data-is-town-online'
const townOnlineTabs = document.querySelector(`[${dataTownOnlineAttrName}]`)

if (townOnlineTabs) {
  sendYaGoal(
    isFeatureFlagEnabledHTML({ dataAttr: `${dataTownOnlineAttrName}` })
      ? TOWN_ONLINE_GOALS.viewOnlineTab
      : TOWN_ONLINE_GOALS.viewClinicTab,
  )
}
